import { useIntl } from 'react-intl';

export const LINE_ITEMS_COLUMN_VISIBILITY_KEY = 'lineItemsList';

// Assumed (ticket does not define it): every column except name, leading and actions can be hidden.
export const LINE_ITEMS_HIDEABLE_COLUMN_IDS = ['pricingModel', 'status', 'duration', 'lastUpdate', 'budgetSpend'];

/** Labels of the hideable columns plus the name entry shown (always checked) in the column visibility menu. */
export function useLineItemsColumnLabels(): Record<string, string> {
  const { formatMessage } = useIntl();

  return {
    budgetSpend: formatMessage({ defaultMessage: 'Budget Spent', id: 'lineItems.list.toolbar.budget' }),
    duration: formatMessage({ defaultMessage: 'Current / Total days', id: 'lineItems.list.toolbar.days' }),
    lastUpdate: formatMessage({ defaultMessage: 'Last Update', id: 'lineItems.list.toolbar.date' }),
    name: formatMessage({ defaultMessage: 'Line Item name', id: 'lineItems.list.columnVisibility.name' }),
    pricingModel: formatMessage({ defaultMessage: 'Pricing Model', id: 'lineItems.list.toolbar.pricing' }),
    status: formatMessage({ defaultMessage: 'Status', id: 'lineItems.list.toolbar.status' })
  };
}
